import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';
import { devAnalyticsClient } from '@dev-agents/analytics';
import { envType, getEnvType } from '@dev-agents/env';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import '@atlaskit/css-reset/bundle.css';
import './global.css';
import { AppWithAuthAndTenantContext } from './ui/AppWithAuthAndTenantContext';
import { initReactUFO } from './utils/analytics/ufo/initUFO';

Sentry.init({
	environment: getEnvType(),
	enabled: getEnvType() !== envType.LOCAL,
	dsn: 'https://aa7f49d6af9f98e93324071287d92bb8@o55978.ingest.us.sentry.io/4508946351521793',
	tracesSampleRate: 1.0, // Capture 100% of the transactions
});

initReactUFO(devAnalyticsClient);

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<AtlassianRelayEnvironmentProvider>
		<AppWithAuthAndTenantContext />
	</AtlassianRelayEnvironmentProvider>,
);
